import { render } from "./Badge.vue?vue&type=template&id=18ab2e7e"
import script from "./Badge.vue?vue&type=script&lang=ts"
export * from "./Badge.vue?vue&type=script&lang=ts"
script.render = render

export default script